import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "content"]

  connect() {
    const checked = this.sourceTargets.find((source) => source.checked)
    if (checked) this.onSourceChange({ target: checked })
  }

  onSourceChange(e) {
    const sourceValue = e.target.value
    this.contentTargets.forEach((contentEl) => {
      if (contentEl.dataset.id === sourceValue) {
        contentEl.disabled = false
        contentEl.classList.remove("hidden")
      } else {
        contentEl.disabled = true
        contentEl.classList.add("hidden")
      }
    })
  }
}
